// extracted by mini-css-extract-plugin
export default {"modalBackground":"styles_modalBackground__C5xin","modalContainer":"styles_modalContainer__EXxfB","titleCloseBtn":"styles_titleCloseBtn__Qb6fY"};